import { useQuery } from '@tanstack/react-query';
import { fetchCodeList } from '../../store/apis/expenseService'; // adjust the path if needed

function useExpenseTypes(category) {
  return useQuery({
    queryKey: ['useExpenseTypes', category],
    enabled: !!category, // Only fetch if category is selected
    queryFn: () =>
      fetchCodeList({ codeType: 'EXPENSE_TYPE', param1: category }),
  });
}

export default useExpenseTypes;
